module.exports = __webpack_public_path__ + "img/ball_5.4c5d13f1.png";